import { IListViewField } from "src/components/Shared/ILIstViewField";
import { NewDocumentListView } from "src/components/Shared/NewDocumentListView";
import { AppEntities } from "src/config/entities";
import Popover from "devextreme-react/popover";
import { ListView } from "src/components/Shared/ListViews/ListView";
import { DocumentListViewToolbar } from "src/components/Shared/ListViews/DocumentListViewToolbar";
import { DocumentListViewDefaultToolbarButtons } from "src/components/Shared/ListViews/DocumentListViewDefaultToolbarButtons";
import { ListviewToolbarSubmenuButton } from "src/components/Shared/ListViews/ListviewToolbarSubmenuButton";
import { ListviewToolbarMoreActions } from "src/components/Shared/ListViews/ListviewToolbarMoreActions";

const DistributionOfLandedCostsList = () => {
  const renderVendorInvoiceList = (eventData: any) => {
    console.log("renderVendorInvoiceList", eventData);
    const vendorInvoiceList = eventData.data.vendorInvoiceList;
    if (!vendorInvoiceList || vendorInvoiceList.length === 0) return <>No vendor invoices</>;

    return (
      <>
        <span id={`distribution_of_landed_cost_${eventData.data.id}`} className={""}>
          <span>{`(${eventData.data.vendorInvoiceList ? eventData.data.vendorInvoiceList.length : 0}) vendor invoices`}</span>
        </span>
        <Popover target={`#distribution_of_landed_cost_${eventData.data.id}`} showEvent="mouseenter" hideEvent="mouseleave" position="bottom" width={300}>
          <ul>
            {eventData.data.vendorInvoiceList.map((vendorInvoice: string, index: number) => {
              return (
                <li key={index}>
                  <b>{vendorInvoice}</b>
                </li>
              );
            })}
          </ul>
        </Popover>
      </>
    );
  };

  const fields: IListViewField[] = [
    {
      fieldName: "companyName",
      title: "Company"
    },
    {
      fieldName: "divisionName",
      title: "Division"
    },
    {
      fieldName: "totalAmount",
      title: "TotalAmount"
    },
    {
      fieldName: "vendorInvoiceList",
      title: "Vendor Invoices",
      cellRender: renderVendorInvoiceList
    }
  ];

  return (
    <>
      <ListView
        // createDocumentActions={createDocumentActions}
        fields={fields}
        entity={AppEntities.DistributionOfLandedCosts}
        // createDependedDocumentActions={createDocumentActions}
        // createMoreActions={[]}
      >
        <DocumentListViewToolbar>
          <DocumentListViewDefaultToolbarButtons>{/* <ListviewToolbarSubmenuButton /> */}</DocumentListViewDefaultToolbarButtons>
          <ListviewToolbarMoreActions />
        </DocumentListViewToolbar>
      </ListView>{" "}
    </>
  );
};

export default DistributionOfLandedCostsList;
